"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlButton = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var ControlButton = (0, styled_components_1.default)(ui_butticon_1.Butticon)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n\n  &:focus {\n    position: absolute;\n  }\n\n  right: ", ";\n  top: ", ";\n  z-index: ", ";\n"], ["\n  position: absolute;\n\n  &:focus {\n    position: absolute;\n  }\n\n  right: ", ";\n  top: ", ";\n  z-index: ", ";\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (0, ui_symbols_1.calcSpace)(3, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (0, ui_symbols_1.calcSpace)(3, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, ui_symbols_1.PLANE.STACKS.high);
exports.ControlButton = ControlButton;
var templateObject_1;